module.exports = __webpack_public_path__ + "img/polygon.1ee4a1ab.png";